import { exercises as builtInExercises, getBaseExercises } from "../data/exercises/index";
import * as localStorageUtils from "../utils/localStorageUtils";

function slugifyName(name) {
    return String(name || "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
        .replace(/_+/g, "_");
}

export function getAllExercisesCatalog(lang = null) {
    const customExercises = typeof localStorageUtils.getCustomExercises === "function"
        ? localStorageUtils.getCustomExercises()
        : [];
    
    const cachedStr = typeof localStorage !== 'undefined' ? localStorage.getItem('cached_exercises') : null;
    if (cachedStr) {
        try {
            const cachedExercises = JSON.parse(cachedStr);
            if (Array.isArray(cachedExercises) && cachedExercises.length > 0) {
                return [...cachedExercises, ...customExercises];
            }
        } catch (_) {}
    }

    let targetLang = lang;
    if (!targetLang && typeof window !== 'undefined') {
        const path = window.location.pathname || "";
        try {
            targetLang = path.startsWith("/uk") ? "uk" : (localStorage.getItem("fitlog_language") || "en");
        } catch (_) {
            targetLang = path.startsWith("/uk") ? "uk" : "en";
        }
    }
    
    const baseline = (typeof getBaseExercises === "function" ? getBaseExercises(targetLang || "en") : null) || builtInExercises;
    return [...baseline, ...customExercises];
}

export function getExerciseById(exerciseId) {
    return getAllExercisesCatalog().find((exercise) => exercise.id === exerciseId) || null;
}

export function mergeCustomExercises(localCustomExercises = [], remoteCustomExercises = []) {
    const merged = new Map();

    [...localCustomExercises, ...remoteCustomExercises].forEach((exercise) => {
        if (exercise && exercise.id) {
            merged.set(exercise.id, exercise);
        }
    });

    return Array.from(merged.values());
}

export function createCustomExercise({ name, muscleGroup, metricType = "strength" }) {
    const trimmedName = String(name || "").trim();
    if (!trimmedName || !muscleGroup) {
        throw new Error("INVALID_CUSTOM_EXERCISE");
    }

    const existingExercises = getAllExercisesCatalog();
    const normalizedName = trimmedName.toLowerCase();
    const duplicate = existingExercises.some(
        (exercise) => String(exercise.name || "").trim().toLowerCase() === normalizedName
    );

    if (duplicate) {
        throw new Error("DUPLICATE_CUSTOM_EXERCISE");
    }

    const baseSlug = slugifyName(trimmedName) || "exercise";
    const existingIds = new Set(existingExercises.map((exercise) => exercise.id));
    let nextId = `custom_${baseSlug}`;
    let suffix = 2;

    while (existingIds.has(nextId)) {
        nextId = `custom_${baseSlug}_${suffix}`;
        suffix += 1;
    }

    const isCardio = metricType === "cardio";

    const customExercise = {
        id: nextId,
        name: trimmedName,
        equipment: isCardio ? "Cardio Machine" : "Other",
        metricType: isCardio ? "cardio" : "strength",
        custom: true,
        muscleGroups: [
            {
                group: muscleGroup,
                priority: "primary",
            },
        ],
    };


    const existingCustomExercises = typeof localStorageUtils.getCustomExercises === "function"
        ? localStorageUtils.getCustomExercises()
        : [];
    const savedExercises = [...existingCustomExercises, customExercise];
    const saved = typeof localStorageUtils.saveCustomExercises === "function"
        ? localStorageUtils.saveCustomExercises(savedExercises)
        : false;
    if (!saved) {
        throw new Error("SAVE_CUSTOM_EXERCISE_FAILED");
    }

    return customExercise;
}
